import ACTIONS from '@/store/storeActions';

const actions = {
  [ACTIONS.ADD_NOTE]: (context, payload) => {
    context.commit(ACTIONS.ADD_NOTE, payload);
  },
  [ACTIONS.REMOVE_NOTE]: (context, payload) => {
    context.commit(ACTIONS.REMOVE_NOTE, payload);
  },
  [ACTIONS.UPDATE_NOTE]: (context, payload) => {
    context.commit(ACTIONS.UPDATE_NOTE, payload);
  }
}

export default actions
